<script>
import BuyNow from './buy-now.vue';
import planPropsMixin from '@/plans/mx/plan-props';

export default {
  mixins: [planPropsMixin],
  render() {
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow {...{ props: { ...this.$props }}} on={this.$listeners} />;
    return null;
  },
};
</script>
